import React, { Component, Suspense } from 'react';
import { Switch, Route, Redirect, BrowserRouter } from 'react-router-dom';


import {ROOMS} from '../shared/rooms';
import {BUSINESSES} from '../shared/businesses';

// import Index from './IndexComponent';
// import Home from './HomeComponent';
// import Header from './HeaderComponent';
// import Footer from './FooterComponent';
// import Businesses from './BusinessComponent';
// import SignUp from './SignUpComponent';
// import ResetPassword from './ResetPasswordComponent';
// import SignIn from './SignIn';
// import Room from './RoomComponent';

//
import {Room_Images} from '../shared/room_images'; 
import {Room_Images_Mobile} from '../shared/room_images_mobile'; 

// import CartPage from './cart/CartPage.js';

// import checkOutView from './checkout/CheckOutView';

import "react-minimal-side-navigation/lib/ReactMinimalSideNavigation.css";

// import Sidebar from "./Sidebar/Sidebar";
// import SidebarLight from "./Sidebar/SidebarLight";

//ProductListing

import ProductList from '../Products/ProductView';

//ProductRooms
// import ProductRooms from '../Products/ProductsRooms';
// import ProductsRoomsView from '../Products/ProductRoomsView';

// //paymentConfirmation
// import ConfirmationPage from './PaymentConfirmation';

// //profile
// import UserProfile from './ProfileComponent';

// //drawer
// import SideDrawer from './drawer/SideDrawer';


// //product_details
// import ProductDetailsView from './productDetails/ProductDetailsView';


// //admin
// import Admin from './Admin/src/AdminComponent';

// //bobza
// import Bobza from './bobza/Bobza';

//toast
import {ToastContainer} from 'react-toastify';


//routes
import UserRoute from './routes/UserRoute';


//primeReact
//import PrimeReact from 'primereact/api';
import 'primereact/resources/themes/saga-orange/theme.css' 

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import ReactLoading from 'react-loading';


//import ProductsRoomsView from '../Products/ProductRoomsView';


const Index = React.lazy(()=> import('./IndexComponent'));
const Home = React.lazy(()=> import('./HomeComponent'));
const Footer = React.lazy(()=> import('./FooterComponent'));
const ContactUs = React.lazy(()=> import('./ContactComponent'));
const OurValues = React.lazy(()=> import('./OurValuesComponent'));
const Team = React.lazy(()=> import('./MeetTheTeam/TeamComponent'));
const SignUp = React.lazy(()=> import('./SignUpComponent'));
const ResetPassword = React.lazy(()=> import('./ResetPasswordComponent'));
const SignIn = React.lazy(()=> import('./SignIn'));
const Room = React.lazy(()=> import('./RoomComponent'));
const CartPage = React.lazy(()=> import('./cart/CartPage.js'));
const checkOutView = React.lazy(()=> import('./checkout/CheckOutView'));
const Sidebar = React.lazy(()=> import('./Sidebar/Sidebar'));
// const ProductList = React.lazy(()=> import('../Products/ProductView'));
const ProductsRoomsView = React.lazy(()=> import('../Products/ProductRoomsView'));
const ConfirmationPage = React.lazy(()=> import('./PaymentConfirmation'));
const UserProfile = React.lazy(()=> import('./ProfileComponent'));
const SideDrawer = React.lazy(()=> import('./drawer/SideDrawer'));
const ProductDetailsView = React.lazy(()=> import('./productDetails/ProductDetailsView'));
const Admin = React.lazy(()=> import('./Admin/src/AdminComponent'));
const Bobza = React.lazy(()=> import('./bobza/Bobza'));
const ServicesRoomsView = React.lazy(()=> import('./service/ServicesView'));
const ServicesDetailsView = React.lazy(()=> import('./service/ServiceDetailsView.js'));
const NotFound = React.lazy(()=> import('./404/404'));
const Cookies = React.lazy(()=> import('./cookie/Cookies'));
const VerifyEmail = React.lazy(()=> import('./verifyEmail/VerifyEmail'));
//const UserRoute = React.lazy(()=> import('./routes/UserRoute'));



class Main extends Component{

    constructor(props) {
        super(props);
        this.state = {
          rooms: ROOMS,
          selectedRoom: null,
          businesses: BUSINESSES,
          selectedBus: null,
          room_images: Room_Images,
          room_images_mobile: Room_Images_Mobile,
        };
        
      }
      
      onRoomSelect(roomName) {
        this.setState({ selectedRoom: roomName});
      }

      onBusSelect(busId) {
        this.setState({ selectedBus: busId});
      }

  render() {

    const IndexPage = () => {
      return (
        <Index />
      );
    }

    const User = ({ match }) => {
      return (
        <div className="d-block">
          <div className="Container" style={{ backgroundColor: "black", height:"100vh" }}>
         
            <Sidebar onClick={(roomName) => this.onRoomSelect(roomName)} />
            <Switch >
              <Route path={match.url} exact={true} component={IndexPage} />
              <Route path={`${match.url}/rooms`} exact={true} component={() => <Home rooms={this.state.rooms} onClick={(roomName) => this.onRoomSelect(roomName)} />} />
              <Route path={`${match.url}/contactus`} exact={true}><ContactUs /></Route>
              <Route path={`${match.url}/ourvalues`} exact={true}><OurValues /></Route>
              <Route path={`${match.url}/meettheteam`} exact={true}><Team /></Route><Route path={`${match.url}/Businesses`} exact={true} businesses={this.state.rooms.filter((room) => room.room_name === this.state.selectedRoom)} />
              <Route path={`${match.url}/signup`} exact={true}><SignUp /></Route>
              <Route path={`${match.url}/signin`} exact={true}><SignIn /></Route>
              <Route path={`${match.url}/forgetpassword`} exact={true}><ResetPassword /></Route>
              <Route path={`${match.url}/room`} exact={true}><Room room_mobile={this.state.room_images_mobile.filter((room_image) => room_image.name === this.state.selectedRoom)[0]} room={this.state.room_images.filter((room_image) => room_image.name === this.state.selectedRoom)[0]}/></Route>
            </Switch>
            <Footer />
          </div>
          
        </div>

      );
    };

    const Products = ({ match }) => {
      return (
        <div>
          <Sidebar onClick={(roomName) => this.onRoomSelect(roomName)} />
          <Switch>
            <Route path={match.url} exact={true}>
              <ProductList />
            </Route>
          </Switch>
        </div>
      );
    };

    const UserProfilePage = ({ match }) => {
      return (
        <div>
          <Sidebar onClick={(roomName) => this.onRoomSelect(roomName)} />
          <Switch>
            <Route path={match.url} exact={true}>
              <UserProfile />
            </Route>
          </Switch>
        </div>
      );
    }; 



    const Dashboard = (match) => {
      return (
        <Switch>
          <Route path={match.url} exact={true} component={Admin} />
        </Switch>
      );
    };

    const BobzaDashboard = (match) => {
      return (
        <Switch>
          <Route path={match.url} exact={true} component={Bobza} />
        </Switch>
      );
    };

    
    return (
      
        <Suspense
          fallback={
            <div className="d-flex justify-content-center align-items-center">
              <ReactLoading
                type="bars"
                color="black"
                height={667}
                width={375}
              />
            </div>
          }
        > 
       
          <BrowserRouter>
            <SideDrawer />
            <ToastContainer />
            <Switch>
              <Route path="/home" component={User} />
              <Route path="/a" component={Dashboard} />
              <Route path="/bobza" component={BobzaDashboard} />
              {<Route path="/products" exact={true} component={Products} />}
              <Route exact path="/cart" component={CartPage} />
              <UserRoute exact path="/checkout" component={checkOutView} />
              
              <Route
                path="/products/:slug"
                exact={true}>
                  <ProductsRoomsView onClick={(roomName) => this.onRoomSelect(roomName)}/>
                </Route>
              
                <Route
                path="/products/:slug"
                exact={true}>
                  <ServicesRoomsView/>
                </Route>

              <Route
                path="/product/:slug"
                exact={true}>
                  <ProductDetailsView onClick={(roomName) => this.onRoomSelect(roomName)}/>
                </Route>

                <Route
                path="/service/:slug"
                exact={true}>
                  <ServicesDetailsView onClick={(roomName) => this.onRoomSelect(roomName)}/>
                </Route>
              {/* <Route
              path="/products/:slug"
              exact={true}
              component={ProductsRoomsView}
            />   
             */}
              
              <Route
                path="/paymentconfirmation"
                exact={true}
                component={ConfirmationPage}
              />
              <Route path="/404" exact={true} component={NotFound} /> 
              <Route path="/verify-email" exact={true} component={VerifyEmail} />
              <UserRoute
                path="/profile"
                exact={true}
                component={UserProfilePage}
              />
              <Redirect to="/home" />
            </Switch>
            <Cookies />
          </BrowserRouter>
        </Suspense>
    );
  }
}

export default Main;